import * as React from 'react';

import { CategoryHeroImage } from '@lendi-jam/category-hero-image';
import { replaceElement } from '@lendi-jam/generic-rich-text';
import parse from 'html-react-parser';

import { CategoryHeroImageContent } from '#contentTypes/categoryPage/HeroImage';

interface PrismicHeroImageProps {
  component: CategoryHeroImageContent;
}

const PrismicHeroImage: React.FC<PrismicHeroImageProps> = ({ component }) => {
  const {
    primary_button,
    primary_button_link,
    secondary_button,
    secondary_button_link,
    hero_component_image,
    hero_image_title,
    hero_image_subtitle,
  } = component.primary;
  const HeroVariant = component.primary.hero_image_variant;
  const PrimaryButton = primary_button.text ? { text: primary_button.text, url: primary_button_link?.url } : undefined;
  const SecondaryButton = secondary_button.text
    ? { text: secondary_button.text, url: secondary_button_link?.url }
    : undefined;
  return (
    <CategoryHeroImage
      variant={HeroVariant}
      alt={hero_component_image?.alt}
      title={hero_image_title.text}
      subtitle={parse(hero_image_subtitle.html, {
        replace: (domNode) => {
          if (domNode.name === 'a') {
            return replaceElement(domNode, HeroVariant === 'dark' ? 'shade.0' : 'shade.800');
          }
          if (domNode.name === 'h2') {
            return <>{domNode.children[0]?.data}</>; // TODO: CUT-335
          }
          return null;
        },
      })}
      imageSharp={hero_component_image?.fluid}
      primaryButton={PrimaryButton}
      secondaryButton={SecondaryButton}
    />
  );
};

export default PrismicHeroImage;
